'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function () {
    (0, _jquery2.default)('#registrationSubmitBtn', this).click(function () {
        var _this = this;

        if (!_abp2.default.session && !(0, _jquery2.default)(this).attr('data-authenticated')) {
            (0, _ajax2.default)({
                url: '/Account/AuthenticateAnonymous',
                method: 'post',
                contentType: 'application/json',
                dataType: 'json'
            }).done(function (res) {
                (0, _jquery2.default)('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
                (0, _jquery2.default)(_this).attr('data-authenticated', 'true');
                (0, _jquery2.default)(_this).closest('form').submit();
            }).fail(function (err) {});
            return false;
        }
        return true;
    });

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var phoneNumberWrapper = _step.value;

            var phoneNumberElement = phoneNumberWrapper.querySelector('#PhoneNumber');
            if (!phoneNumberElement) return {
                    v: void 0
                };

            phoneNumberElement.addEventListener('keyup', function (event) {
                var phoneNumberWithCodeElement = phoneNumberWrapper.querySelector('#PhoneNumberWithCode');
                event.target.value = _common2.default.keepJustNumbers(event.target.value);
                updatePhoneWithCountryCode(event.target, phoneNumberWithCodeElement);
            });
        };

        for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('.phone-number-wrapper')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ret = _loop();

            if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = (0, _getIterator3.default)(document.querySelectorAll('.country-selector > select')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var countrySelector = _step2.value;

            changePrefix(countrySelector);

            (0, _jquery2.default)(countrySelector).on('select2:select', function (event) {
                changePrefix(event.target);
            });
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    function updatePhoneWithCountryCode(phoneNumberElement, phoneNumberWithCodeElement) {
        try {
            if (!phoneNumberWithCodeElement) {
                phoneNumberWithCodeElement = phoneNumberElement.closest('.row').querySelector('#PhoneNumberWithCode');
            }
            var prefixInput = getPhoneCountryCodeElement(phoneNumberElement);

            if (!phoneNumberWithCodeElement || !prefixInput || !phoneNumberElement) return;

            phoneNumberWithCodeElement.value = '+' + prefixInput.value + phoneNumberElement.value;
        } catch (e) {
            console.error('Error in updating phone with country code (updatePhoneWithCountryCode).', e);
        }
    }

    function getPhoneCountryCodeElement(element) {
        var row = element.closest('.row');
        return row.querySelector('.phone-number-prefix');
    }

    function changePrefix(element) {
        try {
            var selectedId = parseInt(element.value);
            var prefixInput = getPhoneCountryCodeElement(element);
            if (!prefixInput || !prefixInput.dataset.source) return;

            var source = JSON.parse(eval(prefixInput.dataset.source));

            var selectedObject = source.find(function (o) {
                return o.Id === selectedId;
            });
            prefixInput.value = '+' + selectedObject.PhoneCountryCode;

            updatePhoneWithCountryCode(element);
        } catch (e) {
            console.error('Error in automatic prefill phone country code. (changePrefix method)', e);
        }
    }

    var emailInput = document.querySelector('input[name="Email"]');
    var lastSentEmail = null;

    if (emailInput) {
        emailInput.addEventListener('blur', function () {
            var email = emailInput.value.trim();

            if (emailInput.validity.valid && email !== lastSentEmail) {
                if (typeof _emailingApi2.default !== 'undefined' && typeof _emailingApi2.default.identifyVisitor === 'function') {
                    _emailingApi2.default.identifyVisitor(email);
                    lastSentEmail = email;
                }
            }
        });
    }
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _common = require('../common');

var _common2 = _interopRequireDefault(_common);

var _emailingApi = require('../cart/emailingApi');

var _emailingApi2 = _interopRequireDefault(_emailingApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/registration.js
// module id = 1081
// module chunks = 1